module.exports = __webpack_public_path__ + "img/rule.604d3752.png";